@let p = product();
@let dp = distinctProduct();
@let selStore = selectedStore();

<div class="row">
  <div class="col-4 quantity">
    <h4 aria-level="2" class="form-label" id="quantity-label">Menge</h4>
    <div class="input-group mb-3 ">
      <div class="select-wrapper">
        <select (change)="onSelectedQuantityChange($event)" class="form-control" id="quantity" aria-labelledby="quantity-label">
          @for (_ of [].constructor(20); track $index; let i = $index) {
            <option [ngValue]="i + 1">{{ i + 1 }}</option>
          }
        </select>
      </div>
    </div>
  </div>

  @if (p && p.datasheetUrl) {
    <div class="col-8 data-sheet">
      <a [href]="p.datasheetUrl" target="_blank" style="text-decoration: none;">
        <button type="button" class="btn btn-small-gray">Produktdatenblatt</button>
      </a>
    </div>
  }
</div>

<!-- a distinct product has been set -->
@if (dp) {
  <!-- ONLINE -->
  <div class="order-tile p-3 my-2 d-flex w-100" [class.disabled]="! dp" [class.selected]="mode() == 'online' || mode() == 'buildup'" (click)="toggleMode('online')" (keydown.enter)="toggleMode('online')" (keydown.space)="toggleMode('online')" role="radio" tabindex="0" [attr.aria-checked]="mode() == 'online' || mode() == 'buildup'" aria-label="Online bestellen">
    <div class="pe-3">
      <svg class="radio" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <circle cx="16" cy="16" r="10" class="inner" />
        <circle cx="16" cy="16" r="14" class="outer" />
      </svg>
    </div>
    <div class="flex-grow-1">
      <span class="heading d-block mb-1">
        Online bestellen
        @if (isInStock() !== undefined) {
          @if (isInStock()) {
            <span [class]="'availability ' + storePickupSpeed()">(verfügbar)</span>
          } @else {
            <span [class]="'availability unavail'">(ausverkauft)</span>
          }
        }
      </span>
      @if (isInStock() !== undefined) {
        @if (isInStock()) {
          <!-- BUILDUP -->
          @if (p.typeId == 2) {
            @let bs = buildupService();
            <div>
              @if (buildupServiceForm) {
                <form class="form-check" novalidate [formGroup]="buildupServiceForm">
                  <input id="buildupCheckbox" formControlName="checked" class="form-check-input buildup-check" type="checkbox" />
                  <label class="form-check-label" for="buildupCheckbox">
                    Aufbauservice
                    @if (bs && bs.assembly) {
                      <span>({{bs.assembly.price}}&nbsp;€)</span>
                    }
                  </label>
                </form>
              }
              @if (buildupChecked() && bs) {
                <div class="d-flex">
                  <p class="{{bs.assembly ? 'txt-active' : 'txt-error'}}">
                    In deiner Region
                    @if (bs.enteredPostalcode) {
                      <span>({{bs.enteredPostalcode}})</span>
                    }
                    @if (! bs.assembly) {
                      <span> nicht </span>
                    }
                    verfügbar
                  </p>
                  <div class="ms-auto text-decoration-underline" (click)="onRecheckAssemblySelection($event)">Erneut prüfen</div>
                </div>
              } @else {
                <p class="info">Prüfe die Verfügbarkeit und den Preis unseres Aufbauservices in deiner Region.</p>
              }
            </div>
          }
          @let dt = p.getDeliveryTime(dp.selectedVariant, dp.distinctId, dp.qualityId);
          <p>
            @if (dt) {
              @if (dt.daysFrom == 0) {
                <span>
                  <span [class.quick]="dt.daysFrom < 8" [class.medium]="dt.daysFrom >= 8" class="deliverytime">Lieferung {{ dt.text }}</span>
                </span>
              }
              @if (dt.daysFrom > 0) {
                <span>
                  <span [class.quick]="dt.daysFrom < 8" [class.medium]="dt.daysFrom >= 8" class="deliverytime">Lieferung ca. {{ dt.text }}</span>
                </span>
              }
              @if (dt.daysFrom > -1) {
                <br>
                }
              }
              <span class="return-info">14 Tage Rückgaberecht</span>
            </p>
          } @else {
            <p>Der von dir gewählte Artikel ist momentan nicht auf Lager.</p>
            <p class="mt-2">
              @if (!isInStock() && isRemindPossible()) {
                <a class="text-decoration-underline" type="button" (click)="openRemindAvailability()">Über Verfügbarkeit benachrichtigen</a>
              }
            </p>
          }
        }
      </div>
    </div>
    <!-- STORE PICKUP -->
    @if (showStorePickupTile()) {
      <div class="order-tile p-3 d-flex w-100 my-2"
        [class.disabled]="isStorePickupDisabledInView()"
        [class.selected]="mode() == 'store'"
        (click)="toggleMode('store')"
        (keydown.enter)="toggleMode('store')"
        (keydown.space)="toggleMode('store')"
        role="radio"
        tabindex="0"
        [attr.aria-checked]="mode() == 'store'"
        aria-label="Abholung in einer Filiale"
        >
        <div class="pe-3">
          <svg class="radio" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <circle cx="16" cy="16" r="10" class="inner" />
            <circle cx="16" cy="16" r="14" class="outer" />
          </svg>
        </div>
        <div class="flex-grow-1">
          <div>
            <span class="d-block mb-1 heading">
              Abholung in einer Filiale
            </span>
            <!-- Store Pickup is disabled by config -->
            @if (! storePickupEnabled()) {
              <div>
                <span>Die Filialabholung ist vorübergehend deaktiviert.</span>
              </div>
            } @else {
              <!-- Store Pickup is disabled in all variants -->
              @if (isStorePickupForbiddenByVariant()) {
                <div>
                  @if (dp) {
                    <span>
                      Deine Auswahl ist aktuell in keiner Filiale abholbar.
                    </span>
                  } @else {
                    <span>
                      Dieses Produkt ist in keiner Filiale abholbar.
                    </span>
                  }
                </div>
              } @else {
                <!-- No Store has the given selection on stock -->
                @if (inStoresAvailable() === 0 && ! isPreorderPossible()) {
                  <p>Klicke hier, um die Verfügbarkeit anzuzeigen.</p>
                } @else {
                  <!-- If a store is selected already, show store info -->
                  @if (selStore) {
                    <div class="selected-store">
                      <div class="store-name">{{ selStore.name }}</div>
                      <!-- if a distinctProduct is set, show explicit info -->
                      @if (dp) {
                        <!-- if the product is not on stock or not at the required quantity -->
                        @if (selStore.stock < selectedQuantity()) {
                          @if (selStore.storePickupPossible && p.getDeliveryTime(dp.selectedVariant, dp.distinctId, dp.qualityId)) {
                            <span [class]="'message ' + storePickupSpeed()">{{ storePickupMessage() }}</span>
                          } @else {
                            <span class="message txt-red">(nicht verfügbar)</span>
                          }
                          <!-- this is definitly not in the selected store available -->
                        } @else {
                          <span class="message txt-green">(verfügbar)</span>
                        }
                      }
                      <div class="mb-1">{{ selStore.address.street }} / {{ selStore.address.postalcode }} {{ selStore.address.city }}</div>
                      @if (selStore.phone) {
                        <div class="mb-1">Telefon: <a [phoneLink]="selStore.phone"></a></div>
                      }
                      <div class="change-store-link" (click)="openLocationFinderModal()">Filiale ändern</div>
                    </div>
                    @if (! selStore.storePickupPossible) {
                      <p class="error">Dieses Produkt ist in der ausgewählten Filiale nicht zur Abholung verfügbar.</p>
                    }
                  } @else {
                    <p>Klicke hier, um die Verfügbarkeit anzuzeigen.</p>
                    @if (inStoresAvailable()) {
                      <p><b>Deine Auswahl ist aktuell in {{ inStoresAvailableString() }} lagernd.</b></p>
                    }
                  }
                  <!-- If no store is selected already, show generic message -->
                }
                <!-- There is at least one store having the given selection and quantity on stock -->
              }
              <!-- Store Pickup is enabled in at least one variant -->
            }
            <!-- Store Pickup is enabled by config -->
          </div>
        </div>
      </div>
    }
  }

  <!-- BUTTON (ONLINE / BUILDUP / STORE) -->
  @if (mode() == 'online' || mode() == 'buildup') {
    <div class="add-to-cart-btn d-flex w-100 my-2">
      @if (isInStock() == true) {
        <button type="button" class="btn btn-primary form-control" [disabled]="! dp" (click)="addToCart(dp)">In den Warenkorb legen</button>
      }
      @if (isInStock() == false) {
        <button type="button" class="btn btn-green form-control" [disabled]="true">Nicht mehr verfügbar</button>
      }
      @if (isInStock() == undefined) {
        <button type="button" class="btn btn-green form-control" [disabled]="true">Bitte triff eine Auswahl</button>
      }
    </div>
  }

  @if (mode() == 'store') {
    <div class="add-to-cart-btn d-flex w-100 my-2">
      <button class="btn btn-primary form-control" (click)="addToCart(dp)" [disabled]="isStorePickupDisabledInView()">In den Warenkorb legen</button>
    </div>
  }
